export default __webpack_public_path__ + "static/media/Amulet of Ancient Python.fc860b7b.jpg";